<template>
  <div class="module--dashboard_dashboard">
    <div class="header-action">
      <div>
      <div v-if="checkPermissions('DASHBOARD_BUTTON_BOOST')" class="fast-refresh-switch">
        <label class="switch">
          <input type="checkbox" v-model="fastRefresh"/>
          <span class="slider"></span>
        </label>
        <p class="refresh-switch-title">{{ $t(`dashboard.label.enable_fast_refresh`) }}</p>
      </div>
      </div>
      <div class="loc-select">
        <select
            v-if="selected_loc_id && default_selected_loc_address && (!result.cpLocQuickInfoDTOS || result.cpLocQuickInfoDTOS.length === 0)"
            v-model="selected_loc_id"
            @change="updateLoc($event.target.value)"
        >
          <option :value="selected_loc_id">{{ default_selected_loc_address }}</option>
        </select>
        <select v-else v-model="selected_loc_id" @change="updateLoc($event.target.value)">
          <option :value="null">{{ $t("select.all") }}</option>
          <option v-for="loc in result.cpLocQuickInfoDTOS" :key="loc.locId" :value="loc.locId">{{
              loc.address
            }}
          </option>
        </select>
      </div>
    </div>
    <el-row :gutter="10" style="margin-bottom: 10px">
      <!-- <el-col :span="6">
        <DashBlock v-loading="loading">
        <div class="chart" ref="chart_area">
          <canvas class="energy-chart" ref="energy_chart"></canvas>
        </div>
        </DashBlock>
      </el-col> -->
      <el-col :span="24">
        <div class="cp-summary">
          <div class="site-wrapper">
            <DashBlock
                class="connector-quick-info"
                style="margin-bottom: 10px"
                v-loading="loading"
            >
              <div
                  class="count"
                  :class="cpUsageType[type]"
                  v-for="type in Object.keys(result.cpUsage)"
                  :key="cpUsageType[type]"
              >
                <div class="value">{{ result.cpUsage[type] }}</div>
                <div class="label">{{ $t(`dashboard.status.${cpUsageType[type]}`) }}</div>
              </div>
            </DashBlock>
            <DashBlock v-if="checkPermissions('Dashboard_summary')" class="summary-wrapper" v-loading="loading">
              <div
                  class="summary"
                  v-for="day in Object.keys(cpSummaryType)"
                  :key="day"
              >
                <div class="label">{{ $t(`dashboard.daterange.${cpSummaryType[day]}`) }}</div>
                <div class="charging-time"
                     v-html="getFormatTime(result.cpSummaryByDayRangeQuickInfoDTO[day].duration)"></div>
                <div class="energy">
                  <div class="value">
                    {{ result.cpSummaryByDayRangeQuickInfoDTO[day].kwh }}
                  </div>
                  <div class="unit">kWh</div>
                </div>
              </div>
            </DashBlock>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="cp-wrapper">
      <div class="cp">
        <div class="connector-wrapper">
          <DashBlock class="connector-status-wrap" v-loading="loading">
            <template v-slot:head>
              <div class="head">
                <div class="title">
                  {{ $t("dashboard.label.charging_status") }}
                </div>
                <div class="action">
                  <div class="next">
                    <div class="icon">
                      <fa :icon="['fas', 'list']"/>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <el-row :gutter="10">
              <el-col v-for="(locInfo,index2) in mapCpQuickInfoDTOS" :key="`loc-${index2}`" style="margin-bottom: 15px">
                <span class="loc-title">{{ locInfo['locAddress'] }}</span>
                <div class="loc-content">
                  <el-col v-for="(zoneInfo,index1) in locInfo['zones']" :key="`zone-${index1}`" class="zone-content">
                    <div class="zone-main">
                      <span class="zone-title">{{ zoneInfo.zoneName }}</span>
                      <div class="zone-c-v">
                        <div class="zone-main-c">
                          <div class="zone-c">
                            <span> {{ $t("dashboard.label.total_current_zone") }}</span>
                            <div class="data" v-html="displayVA(zoneInfo.zoneCurrents,'A')"></div>
                          </div>
                          <span>/</span>
                          <div class="zone-c">
                            <span>{{ $t("dashboard.label.zone_max_physical_current_limit") }}</span>
                            <div class="data" v-html="displayVA([zoneInfo['zoneMaxPhysicalCurrentLimit']],'A')"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="padding-top: 5px">
                      <el-col v-for="(conn,index) in zoneInfo.cps" :key="index" :span="6"
                              class="cps-content" v-show="conn.connectorStatus">
                        <DashBlock class="connector-wrap" :class="conn.connectorStatus">
                          <template v-slot:head>
                            <router-link class="head" :to="`cps/${conn.cpId}`">
                              <div class="name">{{ conn.cpNo }} - {{ conn.connectorId }}</div>
                              <div class="status" :class="conn.connectorStatus">
                                <div class="status-wrap">
                                  <div class="icon" :title="conn.connectorStatus"></div>
                                  <div class="name">{{
                                      conn.connectorStatus ? $t(`dashboard.status.${conn.connectorStatus}`) : "N/A"
                                    }}
                                  </div>
                                </div>
                                <div class="lupd">
                                  {{
                                    conn.lastStatusUpdateDate ? $moment(conn.lastStatusUpdateDate).format("YYYY-MM-DD HH:mm:ss") : ""
                                  }}
                                </div>
                              </div>
                            </router-link>
                          </template>
                          <div class="detail">
                            <div class="charging">
                              <div class="current-status" v-show="page.connectors == 0">
                                <el-row>
                                  <el-col class="consumption" :span="12">
                                    <div class="label">
                                      {{ $t("dashboard.label.consumption") }}
                                    </div>
                                    <div class="data">
                                      <div class="value">
                                        {{ typeof conn.kwh != "undefined" && conn.kwh != null ? conn.kwh : "---" }}
                                      </div>
                                      <div class="unit">kWh</div>
                                    </div>
                                  </el-col>
                                  <el-col :span="12">
                                    <div class="label">
                                      {{ $t("dashboard.label.time") }}
                                    </div>
                                    <div
                                        class="value"
                                        v-html="
                                                        chargingTime(conn.tranStartDate, conn.tranStopDate)
                                                      "
                                    ></div>
                                  </el-col>
                                </el-row>
                                <el-row :gutter="2">
                                  <el-col :span="8" class="multi-value">
                                    <div class="label">
                                      {{ $t("dashboard.label.voltage") }}
                                    </div>
                                    <div class="data" v-html="displayVA(conn.voltages,'V')"></div>
                                  </el-col>
                                  <el-col :span="8" class="multi-value">
                                    <div class="label">
                                      {{ $t("dashboard.label.current") }}
                                    </div>
                                    <div class="data" v-html="displayVA(conn.currents,'A')"></div>
                                  </el-col>
                                  <el-col :span="8">
                                    <div class="label">SoC</div>
                                    <div class="data">
                                      {{ conn.soc | socUnit }}
                                    </div>
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col :span="12" v-if="conn.idTag">
                                    <div class="label">{{ $t("field.cp_sessions_all.id_tag") }}</div>
                                    <div class="data">
                                      <div class="value">{{ conn.idTag }}</div>
                                    </div>
                                  </el-col>

                                  <el-col :span="12" v-if="conn.carRegNo">
                                    <div class="label">{{ $t("field.account_vehicles.car_reg_no") }}</div>
                                    <div class="data">
                                      <div class="value">{{ conn.carRegNo }}</div>
                                    </div>
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col :span="12" v-if="conn.idTag">
                                    <div class="label">{{ $t("field.cp_sessions_all.id_tag") }}</div>
                                    <div class="data">
                                      <div class="value">{{ conn.idTag }}</div>
                                    </div>
                                  </el-col>

                                  <el-col :span="12" v-if="conn.carRegNo">
                                    <div class="label">{{ $t("field.account_vehicles.car_reg_no") }}</div>
                                    <div class="data">
                                      <div class="value">{{ conn.carRegNo }}</div>
                                    </div>
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col>
                                    <div class="start-time">
                                      <div class="label">
                                        {{ $t("dashboard.label.start_from") }}
                                      </div>
                                      <div class="value">
                                        {{
                                          conn.tranStartDate ? $moment(conn.tranStartDate).format("YYYY-MM-DD HH:mm:ssa") : ""
                                        }}
                                      </div>
                                    </div>
                                  </el-col>
                                </el-row>
                                <!-- tran_end -->
                                <el-row v-if="conn.tranStopDate">
                                  <el-col>
                                    <div class="start-time">
                                      <div class="label">
                                        {{ $t("dashboard.label.end_on") }}
                                      </div>
                                      <div class="value">
                                        {{
                                          conn.tranStopDate ? $moment(conn.tranStopDate).format("YYYY-MM-DD HH:mm:ssa") : ""
                                        }}
                                      </div>
                                    </div>
                                  </el-col>
                                </el-row>
                                <el-row v-if="conn.bayStatus">
                                  <el-col>
                                    <div class="start-time">
                                      <div class="label">
                                        <div class="label">{{ $t("dashboard.label.bayStatus") }}</div>
                                      </div>
                                      <div class="value">
                                        {{ conn.bayStatus }}
                                      </div>
                                    </div>
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col>
                                    <div class="start-time">
                                      <div class="label">
                                        {{ $t("dashboard.label.latest_cp_meter_value_time") }}
                                      </div>
                                      <div class="value">
                                        {{
                                          conn['latestCpMeterValueTime'] ? $moment(conn['latestCpMeterValueTime']).format("YYYY-MM-DD HH:mm:ssa") : ""
                                        }}
                                      </div>
                                    </div>
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col>
                                    <div class="last-accepted-profile">
                                      <div class="label">
                                        {{ $t("dashboard.label.last_accepted_profile") }}
                                      </div>
                                      <div class="value">
                                        {{
                                          conn['latestAcceptedChargingProfile'] ? conn['latestAcceptedChargingProfile'] : "---"
                                        }}
                                      </div>
                                      <div class="value" style="margin-left: 5px" v-if="conn['latestAcceptedChargingProfileTime']">
                                        ({{timeAgo(conn['latestAcceptedChargingProfileTime'])}})
                                      </div>
                                    </div>
                                  </el-col>
                                </el-row>
                              </div>
                              <!-- <div class="summary" v-show="page.connectors == 1">
                                <div class="title">
                                  {{ $t("dashboard.label.usage") }}
                                </div>
                                <el-row>
                                  <el-col :span="12" v-if="conn.used_by">
                                    <div class="label">
                                      {{ $t("dashboard.daterange.today") }}
                                    </div>
                                    <div class="energy">
                                      <div class="value">
                                        {{conn.used_by.summary?conn.used_by.summary.today.energy / 1000: 0}}
                                      </div>
                                      <div class="unit">kWh</div>
                                    </div>
                                    <div class="charging-time">
                                      <div class="value" v-html="getFormatTime(conn.used_by.summary? conn.used_by.summary.today.charging_time: 0)"></div>
                                    </div>
                                  </el-col>
                                  <el-col :span="12">
                                    <div class="label">
                                      {{ $t("dashboard.daterange.weekly") }}
                                    </div>
                                    <div class="energy">
                                      <div class="value">{{conn.used_by.summary? conn.used_by.summary.weekly.energy / 1000: 0}}
                                      </div>
                                      <div class="unit">kWh</div>
                                    </div>
                                    <div class="charging-time">
                                      <div class="value" v-html="getFormatTime(conn.used_by.summary? conn.used_by.summary.weekly.charging_time: 0)"></div>
                                    </div>
                                  </el-col>
                                </el-row>
                              </div> -->
                            </div>
                            <!-- <div class="icon"><fa :icon="['fas', 'charging-station']" @click="flipPage" /></div> -->
                          </div>
                        </DashBlock>
                      </el-col>
                    </div>
                  </el-col>
                </div>
              </el-col>
            </el-row>
          </DashBlock>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashBlock from "@/components/modules/dashboard/DashBlock";
import "@/utils/chartjs-doughnut-inner-text.js";
import {mapState} from 'vuex';
import Decimal from "decimal.js";

export default {
  components: {
    DashBlock,
  },
  async mounted() {
    this.loading = true;
    const locId = this.$route.query.loc_id;
    const locAddress = this.$route.query.loc_address;
    if (locId) {
      this.selected_loc_id = this.$route.query.loc_id;
      this.default_selected_loc_address = locAddress;
    }
    this.fetchData().then();
    this.iid = setInterval(this.fetchData, 1000 * 60);
    this.loading = false;
  },
  computed: {
    ...mapState({
      permissions: state => state.user.user_info.permissions
    }),
  },
  watch: {
    fastRefresh(enable) {
      if (this.iid) {
        clearInterval(this.iid);
        this.iid = setInterval(this.fetchData, 1000 * (enable ? 5 : 60));
      }
    }
  },
  methods: {
    checkPermissions(str) {
      return this.permissions.includes(`READ_${str}`.toUpperCase());
    },
    async fetchData() {
      // await this.$axios.get("/quick_info",{
      //   params: {
      //     loc_id: this.selected_loc_id
      //   }
      // }).then((res) => {
      //   this.info = res.data.response.info;
      // });

      await this.$axios.get("/v2/quickInfo", {
        params: {
          locId: this.selected_loc_id
        }
      }).then((res) => {
        this.result = res.data;
        const cpQuickInfoDTOS = this.result['cpQuickInfoDTOS'] || [];
        this.mapCpQuickInfoDTOS = Object.values(
            cpQuickInfoDTOS.reduce((locMap, item) => {
              const locId = item.locId == null ? 0 : item.locId;
              const locAddress = item.locId == null ? 'N/A' : (item.locAddress || '');
              if (!locMap[locId]) {
                locMap[locId] = {
                  locId: locId,
                  locAddress: locAddress,
                  zones: {},
                };
              }
              const zoneId = item.zoneId == null ? 0 : item.zoneId;
              const zoneName = item.zoneId == null ? 'N/A' : (item.zoneName || '');
              if (!locMap[locId].zones[zoneId]) {
                locMap[locId].zones[zoneId] = {
                  zoneId: zoneId,
                  zoneName: zoneName,
                  zoneMaxPhysicalCurrentLimit: item['zoneMaxPhysicalCurrentLimit'],
                  cps: [],
                };
              }
              locMap[locId].zones[zoneId].cps.push(item);
              return locMap;
            }, {})
        ).map(loc => {
          let zonesArr = Object.values(loc.zones);
          zonesArr = zonesArr
              .map(zone => {
                const zoneCurrents = [null, null, null];
                zone.cps.filter(cp => ['Charging', 'SuspendedEV', 'SuspendedEVSE'].includes(cp['connectorStatus'])).forEach(cp => {
                  if (cp.currents) {
                    cp.currents.forEach((val, idx) => {
                      if (val !== null && val !== undefined) {
                        if (zoneCurrents[idx] === null) {
                          zoneCurrents[idx] = new Decimal(0);
                        }
                        zoneCurrents[idx] = zoneCurrents[idx].plus(new Decimal(val));
                      }
                    });
                  }
                });
                return {
                  ...zone,
                  zoneCurrents: zoneCurrents.map(x => x ? x.toNumber() : null),
                };
              })
              .sort((a, b) => (a.zoneId === 0 ? 1 : b.zoneId === 0 ? -1 : 0));
          return {
            ...loc,
            zones: zonesArr,
          };
        });
      });
    },
    // setStatus(val) {
    //   switch (val) {
    //     case "Charging":
    //       this.data.connectors.Charging++;
    //       break;
    //     case "Available":
    //       this.data.connectors.Available++;
    //       break;
    //     case "Unavailable":
    //       this.data.connectors.Unavailable++;
    //       break;
    //   }
    // },
    displayVA(arr, unit) {
      let demo = '<div class="wrap"><div class="value">{val}</div><div class="unit">' + unit + '</div></div>';
      let str = '';
      for (var i in arr) {
        if (arr[i] == null && i == 0) {
          str = demo.replaceAll('{val}', '---');
          break;
        } else if (arr[i] != null) {
          str += demo.replaceAll('{val}', arr[i]);
        }
      }

      return str;
    },
    timeAgo(isoDateStr) {
      try {
        const inputDate = new Date(isoDateStr);
        const now = new Date();
        const diffMs = now - inputDate;

        const diffSec = Math.floor(diffMs / 1000);
        const diffMin = Math.floor(diffSec / 60);
        const diffHour = Math.floor(diffMin / 60);
        const diffDay = Math.floor(diffHour / 24);

        if (diffDay > 0) return `${diffDay} ${this.$t('dashboard.unit.time.day_ago')}`;
        if (diffHour > 0) return `${diffHour} ${this.$t('dashboard.unit.time.hr_ago')}`;
        if (diffMin > 0) return `${diffMin} ${this.$t('dashboard.unit.time.min_ago')}`;
        return `${diffSec} ${this.$t('dashboard.unit.time.sec_ago')}`;
      }catch(err) {
        return 'N/A'
      }
    },
    chargingTime(start, stop) {
      if (start == null) {
        return this.getFormatTime("error");
      } else {
        let startTime = new Date(start).getTime();
        let stopTime = new Date(stop).getTime();
        let nowTime = new Date().getTime();
        return this.getFormatTime(((stopTime || nowTime) - startTime) / 1000);
      }
    },
    flipPage() {
      if (this.page.connectors == 0) {
        this.page.connectors = 1;
      } else {
        this.page.connectors = 0;
      }
    },
    updateLoc(loc_id) {
      this.selected_loc_id = loc_id || null;
      const url = new URL(window.location.href)
      if (!loc_id) url.searchParams.delete('loc_id')
      else url.searchParams.set('loc_id', loc_id)
      url.searchParams.delete('loc_address')
      window.history.replaceState({}, '', url.toString());
      this.fetchData();
      console.log("loc_id: ", loc_id);
    }
  },
  filters: {
    socUnit(value) {
      return value ? `${value}%` : "---";
    },
  },
  data() {
    return {
      fastRefresh: false,
      iid: null,
      chart: {},
      loading: false,
      locs: [],
      selected_loc_id: null,
      default_selected_loc_address: null,
      mapCpQuickInfoDTOS: [],
      result: {
        cpLocQuickInfoDTOS: [],
        cpQuickInfoDTOS: [],
        cpSummaryByDayRangeQuickInfoDTO: {
          last7daysSummary: {
            duration: 0,
            kwh: 0
          },
          todaySummary: {
            duration: 0,
            kwh: 0
          },
          yesterdaySummary: {
            duration: 0,
            kwh: 0
          },
        },
        cpUsage: {
          noOfAvailableConnectors: 0,
          noOfChargingConnectors: 0,
          noOfUnAvailableConnectors: 0
        },
      },
      cpUsageType: {
        noOfAvailableConnectors: "Available",
        noOfChargingConnectors: "Charging",
        noOfUnAvailableConnectors: "Unavailable"
      },
      cpSummaryType: {
        yesterdaySummary: "yesterday",
        todaySummary: "today",
        last7daysSummary: "weekly"
      },
      info: {
        acc_charging_status: {},
        cp_status: {},
        cp_usage: {},
        site_usage: {
          today: {
            energy: 0,
          },
        },
        refs: {
          cp_connectors: {},
          cps: {},
        },
      },

      data: {
        connectors: {
          Charging: 0,
          Available: 0,
          Unavailable: 0,
        },
      },

      connectors: [],

      page: {
        connectors: 0,
      },
    };
  },
};
</script>

<style lang="scss">
.module--dashboard_dashboard {
  height: 100%;
  min-width: 1024px;

  .loc-select {
    margin-bottom: 10px;
    text-align: right;

    select {
      height: 30px;
      line-height: 30px;
    }
  }

  .cp-summary {
    .site-wrapper {
      .connector-quick-info {
        .content {
          display: flex;

          .count {
            // display: flex;
            width: 100%;
            text-align: center;

            .value {
              font-size: 30px;
              margin-right: 10px;
              display: inline-block;
            }

            .label {
              font-size: small;
              display: inline-block;
              vertical-align: text-bottom;
            }

            &.Charging > .value {
              color: orange;
            }

            &.Available > .value {
              color: #3fff00;
            }

            &.Unavailable > .value {
              color: red;
            }
          }
        }
      }

      .summary-wrapper {
        .content {
          display: flex;

          .summary {
            width: 100%;
            text-align: center;

            .label {
              font-size: large;
              margin-bottom: 15px;
            }

            .energy,
            .charging-time {
              // display: flex;
              .wrap {
                // display: flex;
                display: inline-block;
              }

              .value {
                font-size: 30px;
                display: inline-block;
              }

              .unit {
                font-size: small;
                display: inline-block;
                color: #aaa;
              }
            }

            .energy {
              .value {
                margin-right: 5px;
              }
            }
          }
        }
      }
    }
  }

  .cp-wrapper {
    .connector-wrapper {
      .connector-status-wrap {
        .el-col-6 {
          // min-width: 230px;
        }

        & > .head {
          display: flex;
          justify-content: space-between;
          padding: 7px 10px;

          .action {
            .next {
              color: white;
              background: #414e75;
              width: 25px;
              height: 25px;
              border-radius: 3px;
              cursor: pointer;

              .icon {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
              }
            }
          }
        }

        .loc-title {
          font-weight: bold;
          font-size: 18px;
          margin-left: 5px;
          color: #45adff;
        }

        .loc-content {
          background-color: #f5f5f5;
          padding: 10px 10px 5px 10px !important;
          border-radius: 6px;
          display: flex;
          flex-direction: column;

          .zone-title {
            color: #636363;
            font-size: 16px;
            font-weight: bold;
            margin-left: 5px;
          }

          .zone-content {
            padding: 0 !important;

            .cps-content {
              margin-bottom: 10px;
            }
          }

          .zone-main {
            display: flex;
            gap: 30px;
            align-items: center;

            .zone-c-v {
              display: flex;
              flex-direction: row;
              gap: 20px;
              font-size: 14px;
              font-weight: bold;
              color: #636363;

              .zone-main-c {
                display: flex;
                flex-direction: row;
                gap: 5px;
              }

              .zone-v, .zone-c {
                display: flex;
                flex-direction: row;
                gap: 5px;

                .data {
                  display: flex;
                  gap: 5px;
                  font-size: 13px;
                  font-weight: normal;
                  color: black;

                  .wrap {
                    display: flex;
                    align-items: end;

                    .unit {
                      font-size: 10px;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .el-row {
        .el-col {
          .connector-wrap {
            height: 195px;

            &.Offline {
              opacity: .5;
            }

            .head {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 2px 10px;
              background: #414e75;
              color: white;
              border-top-left-radius: 5px;
              border-top-right-radius: 5px;
              text-decoration: none;
              height: 35px;

              .name {
                // font-size: small;
                font-size: 14px;
              }

              .lupd {
                font-size: 12px;
                color: white;
                zoom: .9;
              }

              .status {
                display: flex;
                flex-direction: column;
                justify-items: center;
                align-items: flex-end;

                .status-wrap {
                  display: flex;
                  align-items: center;
                }

                &.Unavailable {
                  color: red;

                  .icon {
                    background: red;
                  }
                }

                &.Available {
                  color: #3fff00;

                  .icon {
                    background: #3fff00;
                  }
                }

                &.Charging {
                  color: dodgerblue;

                  .icon {
                    background: dodgerblue;
                  }
                }

                &.Offline {
                  color: #ccc;

                  .icon {
                    background: #ccc;
                  }
                }

                .icon {
                  height: 12px;
                  width: 12px;
                  border-radius: 50%;
                  margin-right: 2px;
                  // border: 1px solid #f9f9f9;
                  background: yellow;
                }

                .name {
                  font-size: x-small;
                }

                .label {
                  font-size: small;
                }
              }
            }

            .content {
              padding: 5px 10px;

              .detail {
                height: 100%;
                position: relative;

                [class*=el-col-] {
                  line-height: 1.3;
                }

                & > .icon {
                  position: absolute;
                  bottom: 0;
                  right: 0;
                  color: #d9d9d9;
                }

                .used_by {
                  // font-size: 14px;
                }

                .label {
                  font-size: x-small;
                  font-weight: bold;
                }

                .data {
                  // display: flex;
                  // flex-wrap: wrap;
                  line-height: 1.2;

                  .wrap {
                    display: inline-block;

                    .value {
                    }
                  }
                }

                .multi-value {
                  .data {
                    .wrap {
                      &:not(:last-child)::after {
                        content: "/";
                        font-size: x-small;
                        margin-left: 2px;
                        margin-right: 2px;
                      }
                    }
                  }
                }

                .value {
                  display: flex;
                }

                .data,
                .value > .wrap {
                  .value {
                    display: inline-block;
                    font-size: small;
                    // font-size: large;
                  }

                  .unit {
                    display: inline-block;
                    font-size: x-small;
                  }
                }

                .not-in-use {
                  height: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 35px;
                  color: #d9d9d9;
                }

                .start-time, .last-accepted-profile {
                  .label {
                    display: inline-block;
                    margin-right: 5px;
                  }

                  .value {
                    font-size: small;
                    display: inline-block;
                  }
                }

                .charging {
                  height: 100%;

                  & > .summary {
                    height: 100%;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    // align-items: center;
                    justify-content: center;

                    .title {
                      font-weight: normal;
                    }

                    .label {
                      font-weight: normal;
                    }

                    .value {
                      justify-content: center;
                    }

                    .energy {
                      .value,
                      .unit {
                        display: inline-block;
                      }

                      .unit {
                        font-size: x-small;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .header-action {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 5px 0;

    .loc-select {
      margin-bottom: 0 !important;
    }
  }

  .fast-refresh-switch {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;

    .refresh-switch-title {
      margin: 0;
      font-size: 13px;
    }

    .switch {
      position: relative;
      display: inline-block;
      width: 36px;
      height: 20px;
    }

    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      transition: .4s;
      border-radius: 34px;
    }

    .slider:before {
      position: absolute;
      content: "";
      height: 14px;
      width: 14px;
      left: 3px;
      bottom: 3px;
      background-color: white;
      transition: .4s;
      border-radius: 50%;
    }

    input:checked + .slider {
      background-color: #45adff;
    }

    input:checked + .slider:before {
      transform: translateX(16px);
    }
  }
}
</style>
